import { memo, useEffect, useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';
import { assetsClipCreateFullLengthCreate } from '@goldcast/api/content';
import ClipPlayerWrapper from '../Clip/ClipPlayer/ClipPlayerWrapper';
import RecordingsPageInternal from './RecordingsPageInternal';
import { core } from '@/stores/core';
import { showErrorToast } from '@/libs/toast/toast';
import { useAppContext } from '@/context/AppContext/AppContext';

const RecordingsPage = () => {
  const navigate = useNavigate();
  const { logger } = useAppContext();
  const coreStore = useSyncExternalStore(core.subscribe, core.getSnapshot);

  const handleTranscriptError = (err: any) => {
    navigate(`/error/${err?.statusCode}`, { replace: true });
  };

  useEffect(() => {
    if (!coreStore.content) {
      return;
    }
    if (!coreStore.content.full_length_asset_id) {
      assetsClipCreateFullLengthCreate({ body: { content_id: coreStore.content.id } })
        .then(res => {
          core.update(data => ({
            ...data,
            content: { ...data.content, full_length_asset_id: res.id }
          }));
        })
        .catch(() => {
          showErrorToast('Something went wrong loading full recording. Please try again.');
          logger.error(`Error creating full lenght clip for ${coreStore.content!.id}`);
          navigate(`/${coreStore.content!.project.id}/${coreStore.content!.id}/clips`);
        });
    }
  }, [coreStore.content, navigate]);

  return (
    <ClipPlayerWrapper
      clipId={coreStore.content?.full_length_asset_id ?? ''}
      handleTranscriptError={handleTranscriptError}
      parentContext="RecordingsPage"
      useNewSkeletonLoader
    >
      <RecordingsPageInternal canShow={!!coreStore.content?.full_length_asset_id} />
    </ClipPlayerWrapper>
  );
};

export default memo(RecordingsPage);
